import { defineStore } from 'pinia'
import httpClient from '@/api/httpClient'
import { useMessagesStore } from '@/stores/messages'

export const usePageStore = defineStore('page', {
  state: () => ({
    page: {
      id: null,
      issue: {},
      title: '',
      slug: '',
      notes: ''
    }
  }),

  actions: {
    async fetch(pageId) {
      return httpClient
        .get(`/api/internal/pages/${pageId}`)
        .then(response => {
          this.page = response.data.page
        })
        .catch(err => {
          console.error(err)
          useMessagesStore().addError(err)
        })
    },

    async update() {
      const { page } = this

      return httpClient
        .patch(
          `/api/internal/pages/${page.id}`,
          { page }
        )
        .then(({ data }) => {
          this.page = data.page
        })
        .catch(err => {
          console.error(err)
          useMessagesStore().addError(err)
        })
    }
  }
})
